export default __webpack_public_path__ + "static/media/org-name.193951bf.svg";